const capitalise = string => string ? string.charAt(0).toUpperCase() + string.slice(1) : string;

export default capitalise;
